<template>
  <div>
    <nav-bar />
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card :loading="loading" class="fill-height">
            <v-card-title class="text-capitalize">
              {{ deviceType }} {{ deviceId }}
            </v-card-title>
            <v-card-subtitle class="caption">
              <span class="font-weight-bold"> Last Updated on : </span>
              {{ lastUpdatedAt }}
            </v-card-subtitle>
            <v-container v-if="!loading" fluid>
              <top-metrics
                :deviceType="deviceType"
                :isEcofrostV4="isEcofrostV4"
                :currentMeasurements="currentDetails"
                :waterOutput="flow"
                :fault="fault"
              />
              <v-row justify="space-around" align-content="space-around">
                <v-col cols="12" sm="12" md="12" lg="9">
                  <v-container class="pa-0">
                    <v-row justify="space-around" align-content="space-around">
                      <v-col
                        cols="6"
                        sm="6"
                        md="5"
                        lg="5"
                        align-self="center"
                        justify-self="center"
                      >
                        <v-menu
                          v-model="fromDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="fromDateFormated"
                              label="From"
                              prepend-icon="mdi-calendar"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="from"
                            no-title
                            @input="fromDateMenu = false"
                            color="primary"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="6"
                        sm="6"
                        md="5"
                        lg="5"
                        align-self="center"
                        justify-self="center"
                      >
                        <v-menu
                          v-model="toDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="toDateFormated"
                              label="To"
                              prepend-icon="mdi-calendar"
                              v-on="on"
                            ></v-text-field>
                          </template>

                          <v-date-picker
                            v-model="to"
                            no-title
                            @input="toDateMenu = false"
                            color="primary"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="6"
                        sm="6"
                        md="2"
                        lg="2"
                        class="text-center"
                        align-self="center"
                        justify-self="center"
                      >
                        <v-btn color="primary" @click="updateGraph">
                          <v-icon left> mdi-database-search </v-icon>
                          Search
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <v-card height="445px" :loading="chartLoading" outlined>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                absolute
                                top
                                left
                                fab
                                x-small
                                color="primary"
                                v-if="deviceType === 'ecotron'"
                                @click="overlay = true"
                                v-on="on"
                              >
                                <v-icon x-small> mdi-file-excel </v-icon>
                              </v-btn>
                            </template>
                            <span>Download monthly report</span>
                          </v-tooltip>
                          <chart :options="chartOptions" />
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="3">
                  <v-card height="550px" outlined class="pa-0">
                    <v-card-title class="caption">
                      MEASUREMENTS
                      <v-spacer></v-spacer>
                      <v-btn
                        x-small
                        class="caption"
                        fab
                        color="primary"
                        dark
                        text
                        @click="clearAllMeasurements"
                      >
                        <v-icon> mdi-restore </v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-list class="scroll-box">
                      <v-list-item
                        v-for="m in measurements"
                        :key="m.label"
                        style="height: 35px"
                      >
                        <v-switch
                          v-model="m.display"
                          :label="m.fullform"
                          color="primary"
                          :loading="m.loading"
                          @change="manipulateChart(m)"
                        ></v-switch>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <performance-metrics
                    :deviceType="deviceType"
                    :deviceId="deviceId"
                    :from="from"
                    :to="to"
                    :updatedAt="currentDetails.updatedAt"
                    @pumpPower="calculateWaterOutput"
                    ref="updatePerformanceMetrics"
                  />
                </v-col>
              </v-row>
              <v-row v-if="deviceType === 'ecotron'">
                <v-col cols="12">
                  <design-description
                    :deviceType="deviceType"
                    :deviceId="deviceId"
                  />
                </v-col>
              </v-row>
              <v-row v-else-if="deviceType === 'ecofrost'">
                <v-col cols="12">
                  <crop-details
                    :deviceType="deviceType"
                    :deviceId="deviceId"
                    :from="from"
                    :to="to"
                    ref="updateCrop"
                  />
                </v-col>
              </v-row>
              <v-overlay opacity="0.5" z-index="5" :value="overlay" light>
                <download-xlsx
                  @closeDownload="overlay = false"
                  :minDate="currentDetails.createdAt.split('T')[0]"
                  :maxDate="currentDetails.updatedAt.split('T')[0]"
                  :deviceType="deviceType"
                  :deviceId="deviceId"
                />
              </v-overlay>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  getFromDate,
  dateOnlyFormat,
  dateFormat24hr,
  getDiffInDays
} from '../plugins/date';
import { nodeRestApi } from '../plugins/api';
import { Chart } from 'highcharts-vue';
import { chartOptions } from '../plugins/graph/graphData';
import {
  fetchChartOptions,
  addMeasurementToChart,
  removeMeasurementFromChart
} from '../plugins/graph/graphFunctions/index.js';
import PerformanceMetrics from '@/components/PerformanceMetrics.vue';
import TopMetrics from '@/components/TopMetrics.vue';
import DesignDescription from '@/components/DesignDescription.vue';
import DownloadXlsx from '@/components/DownloadXlsx.vue';
import CropDetails from '@/components/CropDetails.vue';
import NavBar from '@/components/NavBar.vue';
import ecofrostMeasurements from '../plugins/measurements/ecofrost';
import ecofrostV4Measurements, {
  buildMeasurementsFromV4Params,
  isEcofrostV4
} from '../plugins/measurements/ecofrost-v4';

export default {
  name: 'device-details',
  components: {
    Chart,
    TopMetrics,
    PerformanceMetrics,
    DesignDescription,
    DownloadXlsx,
    CropDetails,
    NavBar
  },
  data() {
    return {
      deviceType: '',
      deviceId: '',
      loading: true,
      currentDetails: {},
      fromDateMenu: false,
      from: '',
      toDateMenu: false,
      to: '',
      measurements: [],
      chartOptions,
      chartLoading: false,
      selectedMeasurements: [],
      defaultMeasurements: [],
      flow: 0,
      fault: '',
      overlay: false,
      isEcofrostV4: false
    };
  },
  computed: {
    fromDateFormated() {
      return dateOnlyFormat(this.from);
    },
    toDateFormated() {
      return dateOnlyFormat(this.to);
    },
    lastUpdatedAt() {
      return dateFormat24hr(this.currentDetails.updatedAt);
    }
  },
  watch: {},
  methods: {
    async updateGraph() {
      await this.$store.commit('setError', false);
      try {
        if (this.getDiffInDays(this.from, this.to, 30)) {
          //chart loading
          this.chartLoading = true;
          //getting selected measurements
          this.selectedMeasurements = this.measurements.filter(m => m.display);

          //fetching chartOptions
          let httpRequests = [
            this.fetchChartOptions(nodeRestApi, this.chartOptions, {
              deviceType: this.deviceType,
              topic: this.deviceId,
              from: this.from, // "2026-05-06" (date only)
              to: this.to, // "2026-05-06" (date only)
              params: this.selectedMeasurements
            }),
            this.$refs.updatePerformanceMetrics.updatePMetrics()
          ];
          if (this.deviceType === 'ecofrost') {
            httpRequests.push(this.$refs.updateCrop.updateCropDetails());
          }
          await Promise.all(httpRequests);

          // close chart loading
          this.chartLoading = false;
        } else {
          throw 'Date range should not be greater than 30 days';
        }
      } catch (error) {
        this.applyValidV4ParamsFromError(error);
        this.$store.commit('setError', this.getGraphErrorMessage(error));
      } finally {
        this.chartLoading = false;
      }
    },
    fetchChartOptions,
    addMeasurementToChart,
    removeMeasurementFromChart,
    getDiffInDays,
    loadEcofrostMeasurements(validV4Params) {
      if (validV4Params && validV4Params.length) {
        this.measurements = buildMeasurementsFromV4Params(validV4Params);
      } else {
        this.measurements = this.isEcofrostV4
          ? ecofrostV4Measurements()
          : ecofrostMeasurements();
      }

      this.defaultMeasurements = this.measurements.filter(m => m.display);
    },
    getGraphErrorMessage(error) {
      if (error.isAxiosError && error.response) {
        const data = error.response.data;
        if (data && data.message) {
          return data.message;
        }
        if (data && data.error && data.error.message) {
          return data.error.message;
        }
      }

      if (error.message) {
        return error.message;
      }

      return error;
    },
    applyValidV4ParamsFromError(error) {
      const validV4Params =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.validV4Params;

      if (validV4Params && validV4Params.length) {
        this.isEcofrostV4 = true;
        this.loadEcofrostMeasurements(validV4Params);
      }
    },
    calculateWaterOutput(pumpPower) {
      let ftg = parseFloat(this.currentDetails.OPW) * 1000;
      if (pumpPower === 5) {
        let ftg1 = Math.ceil((ftg * 220 - 242500) / 3500);
        if (ftg1 <= 0) {
          this.flow = 20;
        } else {
          this.flow = ftg1 * 1.2;
        }
      } else if (pumpPower === 3) {
        let ftg1 = Math.ceil((ftg * 121.2 - 75963.9) / 1707);
        if (ftg1 <= 0) {
          this.flow = 3;
        } else {
          this.flow = ftg1 * 1.2;
        }
      } else if (pumpPower === 1) {
        let ftg1 = Math.ceil((ftg * 121.2 - 75963.9) / 1707);
        if (ftg1 <= 0) {
          this.flow = 2.5;
        } else {
          this.flow = ftg1 * 1.2;
        }
      } else {
        this.flow = 0;
      }
    },
    clearAllMeasurements() {
      // setting display of all measurments as false
      for (const measurement of this.measurements) {
        measurement.display = false;
      }
      this.chartOptions.yAxis.forEach(axis => {
        axis.visible = false;
      });
      // clear series and y axis
      this.chartOptions.series = [];
    },
    async manipulateChart(measurement) {
      measurement.loading = true;
      try {
        if (measurement.display) {
          // add data to graph
          await this.addMeasurementToChart(nodeRestApi, this.chartOptions, {
            deviceType: this.deviceType,
            topic: this.deviceId,
            measurement,
            from: this.from,
            to: this.to
          });
        } else {
          // remove data from graph
          await this.removeMeasurementFromChart(this.chartOptions, {
            measurement
          });
        }
      } catch (error) {
        this.applyValidV4ParamsFromError(error);
        this.$store.commit('setError', this.getGraphErrorMessage(error));
      } finally {
        measurement.loading = false;
      }
    }
  },
  async created() {
    try {
      this.$store.commit('setError', false);
      // set loading to true
      this.loading = true;
      // initialize data
      this.deviceType = this.$route.name;
      this.deviceId = this.$route.params.topic;
      // checking device type
      if (this.deviceType === 'ecotron') {
        // fetching ecotron current device details
        await this.$store.dispatch(
          'ecotron/fetchEcotronCurrent',
          this.deviceId
        );
        // getting ecotron current device details
        this.currentDetails = this.$store.state.ecotron.ecotronCurrent;
        //get measurement details for ecotron
        let measurementModule = await import('../plugins/measurements/ecotron');
        this.measurements = measurementModule.default();
        this.defaultMeasurements = this.measurements.filter(m => m.display);
        //setting from and to date
        this.to = this.currentDetails.updatedAt.split('T')[0]; // "2026-05-06"
        this.from = getFromDate(this.to);
        // get chart data
        await this.fetchChartOptions(nodeRestApi, this.chartOptions, {
          deviceType: this.deviceType,
          topic: this.deviceId,
          from: this.from,
          to: this.to,
          params: this.defaultMeasurements
        });
      } else if (this.deviceType === 'ecofrost') {
        this.isEcofrostV4 = isEcofrostV4({}, this.deviceId);
        this.loadEcofrostMeasurements();

        //fetching ecofrost current device details
        await this.$store.dispatch(
          'ecofrost/fetchEcofrostCurrent',
          this.deviceId
        );
        //getting ecofrost current device details
        this.currentDetails = this.$store.state.ecofrost.ecofrostCurrent;
        this.isEcofrostV4 = isEcofrostV4(this.currentDetails, this.deviceId);
        this.loadEcofrostMeasurements();
        // get faults ToDo -- Change fault type for LP trip
        const refFlts = this.isEcofrostV4
          ? this.currentDetails.MCU_REF_FLTS
          : this.currentDetails.Ref_Flt;
        if (refFlts && refFlts[7] === '1') {
          this.fault = 'HP Trip';
        } else if (refFlts && refFlts[6] === '1') {
          this.fault = 'LP Trip';
        } else {
          this.fault = 'No faults';
        }
        //setting from and to date
        if (this.currentDetails.updatedAt) {
          this.to = this.currentDetails.updatedAt.split('T')[0]; // "2026-05-06"
          this.from = getFromDate(this.to);
        }
        // get chart data
        try {
          await this.fetchChartOptions(nodeRestApi, this.chartOptions, {
            deviceType: this.deviceType,
            topic: this.deviceId,
            from: this.from,
            to: this.to,
            params: this.defaultMeasurements
          });
        } catch (graphError) {
          this.applyValidV4ParamsFromError(graphError);
          this.$store.commit('setError', this.getGraphErrorMessage(graphError));
        }
      }

      // set loading to false
    } catch (error) {
      this.applyValidV4ParamsFromError(error);
      this.$store.commit('setError', this.getGraphErrorMessage(error));
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style>
.scroll-box {
  overflow-y: scroll;
  height: 480px;
}
</style>
